import { useState } from 'react';
import apiService from '../../axios/apiService';
import { message } from 'antd';

export const useRadiologistEmailSender = () => {
  const [loading, setLoading] = useState(false);
  const sendEmail = async (invoiceId) => {
    // Fetch case
    setLoading(true);
    try {
      await apiService.sendRadiologistInvoiceEmail(invoiceId);
      message.success('Invoice email sent successfully');
    } catch (error) {
      console.log('Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    sendEmail,
  };
};
